import { createRouter, createWebHistory } from 'vue-router';
import Home from '@/views/Home.vue';
import Protocol from '@/views/Protocol.vue';
import CreatorCenter from '@/views/CreatorCenter.vue';
import ShopApplyGuide from '@/views/ShopApplyGuide.vue';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home, // 懒加载 Home 页面
  },
  {
    path: '/protocol/:type',
    name: 'Protocol',
    component: Protocol, // 懒加载 Home 页面
    props: true,
  },
  {
    path: '/shop/apply-guide',
    name: 'ShopApplyGuide',
    component: ShopApplyGuide,
  },
  {
    path: '/creator',
    name: 'CreatorCenter',
    component: CreatorCenter,
  },
];

const router = createRouter({
  history: createWebHistory(), // 使用 HTML5 的 History 模式
  routes,
});

export default router;
